import HomCameraCircleIcon from '~/components/Icons/svgs/HomCameraCircleIcon'
import HomGraduationCapCircleIcon from '~/components/Icons/svgs/HomGraduationCapCircleIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import { ProductCategory } from '~/types/tutoring-api'

export default function SessionIcon({
  isExpanded,
  type,
}: {
  isExpanded: boolean
  type: ProductCategory
}): React.ReactElement {
  const icon = type === ProductCategory.TUTORING ? 'hom-graduation-cap-circle' : 'hom-camera-circle'

  const getIconComponent = (name: string): ((props: { [key: string]: any }) => React.ReactElement) => {
    switch (name) {
      case 'hom-graduation-cap-circle':
        return HomGraduationCapCircleIcon
      case 'hom-camera-circle':
        return HomCameraCircleIcon
      default:
        return HomCameraCircleIcon
    }
  }

  if (isExpanded) {
    return (
      <div className="absolute top-1 right-8 filter drop-shadow-xl">
        <SVGIcon icon={getIconComponent(icon)} size={28} />
      </div>
    )
  } else {
    return (
      <div className="absolute top-1/2 right-5 transform -translate-y-1/2 filter drop-shadow-xl">
        <SVGIcon icon={getIconComponent(icon)} size={50} />
      </div>
    )
  }
}
